module.exports = __webpack_public_path__ + "static/media/small-loading.5b3a5fe6.svg";